import { useEffect, useState } from 'react';

interface PlayerDemoProps {
  title: string;
  poster: string;
  episode: number | null;
}

export default function PlayerDemo({ title, poster, episode }: PlayerDemoProps) {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    setPlaying(false);
  }, [episode]);

  const label = episode ? `第 ${episode} 集` : '--';

  return (
    <div className="rounded-lg overflow-hidden border border-background-200 bg-foreground-950">
      <div className="relative w-full aspect-video">
        <img
          src={poster}
          alt={`${title}播放画面`}
          title={`${title} 高清在线观看 - 香草视频`}
          className="w-full h-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/30 flex flex-col items-center justify-center text-center px-4">
          <button
            type="button"
            onClick={() => setPlaying(true)}
            aria-label="播放演示"
            className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 transition-colors cursor-pointer"
          >
            <i className="ri-play-fill text-3xl md:text-4xl" />
          </button>
          <p className="mt-5 text-background-50 font-heading font-semibold text-base md:text-lg">
            {title} · {label}
          </p>
          <p className="mt-2 text-xs md:text-sm text-background-200/80 max-w-md">
            {playing
              ? '播放功能仅做演示，暂不提供真实视频播放内容。'
              : '点击播放按钮查看演示效果（演示性质，无真实视频源）。'}
          </p>
        </div>
      </div>
      <div className="px-4 py-3 flex items-center gap-2 text-xs text-background-200/70 bg-foreground-950">
        <i className="ri-information-line text-accent-400" />
        播放区域仅作功能演示，本站不存储也不传播任何影视资源。
      </div>
    </div>
  );
}